<form [formGroup]="contractDurationForm" autocomplete="off" novalidate>
  <glxy-form-field appearance="outline">
    <glxy-label>{{ 'SALES_CONTRACT_DURATION.DETAILS_SECTION_TITLE' | translate }}</glxy-label>
    <input type="number" matInput formControlName="contractDurationValue" />
    <mat-select formControlName="contractDurationPeriod">
      <mat-option *ngFor="let contractDuration of contractDurationTranslations" [value]="contractDuration.value">
        {{ contractDuration.key | translate }}
      </mat-option>
    </mat-select>
    <glxy-hint *ngIf="isEmbeddedForm">{{ 'SALES_CONTRACT_DURATION.HINT' | translate }}</glxy-hint>
  </glxy-form-field>
</form>
